import React from 'react';
import { Button, Grid, Paper, Tab, Tabs, makeStyles } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import { useSelector } from 'react-redux';
import useTapBarEffects from './hooks';
import { settingsSelector } from '../../store/reducers/settings';
import { logoutAll } from '../../server/RestClients';

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: '#fff',
    textTransform: 'none',
    fontFamily: 'Exo 2',
    marginLeft: theme.spacing(1),
  },
}));

const TabBar = ({ match }) => {
  const css = useStyles();
  const { selectedTab, handleChange, labels, tabStyle } =
    useTapBarEffects(match);
  const settings = useSelector(settingsSelector);
  const videoEnabled = settings?.VideoStream?.enabled ?? false;

  if (match?.params?.page === 'login') {
    return <></>;
  }

  return (
    <>
      <Paper>
        <Grid container justifyContent="center">
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            {labels.map((label) => {
              return (
                <Tab
                  label={label}
                  style={tabStyle}
                  key={label}
                  disabled={!videoEnabled && label === 'Cropping'}
                />
              );
            })}
          </Tabs>
          <Button
            variant="contained"
            disableElevation
            className={css.button}
            disabled={false}
            endIcon={<Close />}
            onClick={logoutAll}
          >
            Logout
          </Button>
        </Grid>
      </Paper>
    </>
  );
};
export default TabBar;
